<template>
  <div id="app">
      <transition name="fade"
                  mode="out-in">
        <!-- 路由中的几个组件在这里被渲染，默认被渲染的为第一个组件，也就是home组件 -->
          <router-view></router-view>
      </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
body {
    margin: 0px;
    padding: 0px;
    /* background: #1F2D3D; */
    font-family: Helvetica Neue, Helvetica,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
    font-size: 16px;
    -webkit-font-smoothing: antialiased;
}

#app {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue